export const companionType: any = {
  partner: "Partner",
  family: "Family",
  friend: "Friend",
  single: "Single",
  business: "Business",
};
